import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'combohubconfiguration',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoading: false,
			isLoadingSearch: false,
			hubzoneid: '',
			HubID: '',
			hubname: '',
			ConnectionID: '',
			changestatus: '',
			DesHubID: '',
			searchConnectionID: '',
			showResulstHubSection: true,
			listSourceHubNameData: [],
			listSourceHubNameDataFlt: [],
			hubListObjData: [],
			fetchedHubs: [],
			listHubZoneData: [],
			listConnectionNameData: [],
			listConnectionNameData2: [],
			listComboHubDetails: [],
			listComboHubDetails: [],
			listSourceHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listSourceHubNameDataObj2: {
				value: "",
				text: "",
			},
			listSourceHubNameDataObj3: {
				value: "",
				text: ""
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			},
			listHubZoneObjDataFlt: {
				value: "",
				text: ""
			},
			listConnectionNameDataObj: {
				value: "",
				text: ""
			},
			listConnectionNameDataObj2: {
				value: "",
				text: "",
				routeMode: ""
			},
			routetypeitemList: {
				value: "",
				text: ""
			},
			routetypelist: [],
			routetypeitem: {
				id: "",
				text: ""
			},
			routetype: '',
			searchHubId: '',
			hubzoneidflt: '',
			isSearchHubZoneErr: 0,
			SearchHubZoneErr: '',
			isSearchRouteTypeErr: 0,
			SearchRouteTypeErr: '',
			isSearchHubErr: 0,
			SearchHubErr: '',
			isSearchConnectionErr: 0,
			SearchConnectionErr: '',
			addmodalShow: false,
			IsActive: false,
			fncAction: '',
			actData: {},
			actualRoute: '',
			hubLoading: '',
			connectionLoading: '',
			actualRouteList: '',
			routetypeListV: '',
			routetypename: '',
			listSourceHubAllData: [],
			pageCount: 0,
			pageNo: 0,
			totalRows: 0
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.getHubZoneData();
		this.getAllHubs();
		this.getSourceHubAllList();
	},
	methods: {
		selectRouteType(routetypeitem) {
			this.routetypeitem = routetypeitem
			this.routetype = this.routetypeitem.id
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listConnectionNameData = []

		},
		selectRouteTypeList(routetypeitemList) {
			this.routetypeitemList = routetypeitemList;
			this.routetypeListV = this.routetypeitemList.id
			this.routetypename = this.routetypeitemList.text
			if (this.routetypename == '' || this.routetypename == undefined) {
				this.isSearchRouteTypeErr = '1',
					this.SearchRouteTypeErr = 'The RouteType field is required.'
			} else {
				this.isSearchRouteTypeErr = '',
					this.SearchRouteTypeErr = ''
			}
		},
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
			this.HubID = ''
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listSourceHubNameDataObj2 = {
				text: '',
				value: ''
			}
			this.DesHubID = ''
			this.$validator.reset()
			if (this.hubzoneid != undefined) {
				this.getSourceHubNameList(this.hubzoneid)
			}
		},
		selectedHubZoneFlt(hubData) {
			this.listHubZoneObjDataFlt = hubData
			this.hubzoneidflt = hubData.value;
			if (this.hubzoneidflt == '' || this.hubzoneidflt == undefined) {
				this.isSearchHubZoneErr = '1',
					this.SearchHubZoneErr = 'The HubZone field is required.'
			} else {
				this.isSearchHubZoneErr = '',
					this.SearchHubZoneErr = ''
			}
			if (this.hubzoneidflt != undefined) {
				this.getSourceHubNameListFlt(hubData.value)
			}
			// this.isSearchHubErr = 0;
			// this.SearchHubErr = ''
			// this.isSearchConnectionErr = 0;
			// this.SearchConnectionErr = ''
			this.listSourceHubNameDataObj3 = {
				text: '',
				value: ''
			}
			this.searchHubID = ''
			this.listConnectionNameDataObj2 = {
				text: '',
				value: '',
				routeMode: ''
			}
			this.searchConnectionID = ''
		},
		selectedSourceHubName2(selectedData) {
			this.listSourceHubNameDataObj2 = selectedData
			this.DesHubID = selectedData.value;
			this.HubName = selectedData.text1;
			this.$validator.validate('DestinationHub')
		},
		selectedHubName(selectedData) {
			this.hubListObjData = selectedData
			this.HubID = selectedData.value;
			this.HubName = selectedData.text;
			this.getAllHubs();
		},
		selectedHubConnection(selectedData) {
			this.listConnectionNameDataObj = selectedData
			this.ConnectionID = selectedData.value;
			this.ConnectionName = selectedData.text;
			if (this.ConnectionID != undefined) {
				this.loadDisplayRoute()
			}
			this.$validator.validate('ConnectionID')
		},
		selectedSourceHubName(selectedData) {
			this.HubID = ''
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listSourceHubNameDataObj = selectedData
			this.HubID = selectedData.value;
			// this.HubName = selectedData.text;
			this.$validator.validate('SourceHub')
		},
		getConnectionListByHubID(searchHubID) {
			this.searchHubID = searchHubID;
			this.getConnectionListByConnectionType();

		},
		getConnectionListByConnectionType() {},

		saveAllocatedstatus(data) {
			var self = this
			if (data.isactive == true) {
				var status = false
			} else {
				var status = true
			}
			this.actData = {
				connectionid: data.connectionid,
				hubid: data.hubid,
				isactive: status,
				createdby: this.useremail,
			}
			this.fncAction = 'saveAllocatedCB'
			this.addmodalShow = true
		},
		saveAllocatedCB() {
			var self = this
			self.isLoadingSearch = true
			this.input = this.actData
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deallocateHubFromConnection',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					self.actData = {}
					self.fncAction = ''
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Successfully Updated!!')
					} else {
						this.$alertify.error(result.data.ReturnMessage)
					}

				})
				.catch((httpException) => {
					self.actData = {}
					self.fncAction = ''
					self.isLoadingSearch = false;
					this.$alertify.error('Allocate Update API Error ')
					console.error('exception is:::::::::', httpException)
				})
		},
		changeHubStatus(data, status) {
			var self = this
			this.actData = ({
				ComboFirstHubId: data.combofirsthubid,
				ComboSecondHubId: data.combosecondhubid,
				HubZoneId: this.hubzoneidflt,
				isActive: status
			})

			this.fncAction = 'changeHubStatusCB'
			this.addmodalShow = true

		},
		changeHubStatusCB() {
			var self = this
			self.isLoadingSearch = true
			this.input = this.actData
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'deActivateComboHub',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					self.actData = {}
					self.fncAction = ''
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Successfully Updated!!')
					} else {
						this.$alertify.error(result.data.ReturnMessage)
					}

				})
				.catch((httpException) => {
					self.isLoadingSearch = false;
					self.actData = {}
					self.fncAction = ''
					this.$alertify.error('Status Update API Error')
					console.error('exception is:::::::::', httpException)
				})
		},
		//to get Connection List on HubID And ConnectionType
		loadDisplayRoute() {
			this.actualRoute = "";
			this.input = {
				"ConnectionID": this.ConnectionID
			}
			axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'loadVendorConnectionRoute',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        }).then(result => {
				if (result) {
					if (result.data.ResultCode == 100) {
						if (result.data.ResponseData.length > 0) {
							this.actualRoute = result.data.ResponseData.join(" - ");
						}
					}
				}
			}, error => {
				console.error(error);
			});
		},
		selectedSourceHubName3(selectedData) {
			this.searchHubID = ''
			this.isSearchHubErr = 0;
			this.SearchHubErr = ''
			this.listSourceHubNameDataObj3 = selectedData
			// this.HubName = selectedData.text;
			this.searchHubId = selectedData.value;
			this.listConnectionNameDataObj2 = {
				text: '',
				value: '',
				routeMode: ''
			}
			this.searchConnectionID = ''
			if (this.searchHubId == '' || this.searchHubId == undefined) {
				this.isSearchHubErr = '1',
					this.SearchHubErr = 'The SourceHubName field is required.'
			} else {
				this.isSearchHubErr = '',
					this.SearchHubErr = ''
				this.isSearchConnectionErr = 0;
				this.SearchConnectionErr = ''
			}
		},
		//to close edit form
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
		getAllHubs() {
			var i = 0;
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var fetchedHubs = result.data.ResponseData
					for (i = 0; i < fetchedHubs.length; i++) {
						this.fetchedHubs.push({
							value: fetchedHubs[i].HubID,
							text: fetchedHubs[i].HubName
						})
					}
				}, error => {
					console.error(error)
				})
		},
		getSourceHubNameList() {
			this.hubLoading = 'Loading Hub...'
			this.listSourceHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameData = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameData.length; i++) {
						this.listSourceHubNameData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
							text1: listSourceHubNameData[i].HubName,
							hubcode: listSourceHubNameData[i].HubCode
						})
					}
				}, error => {
					console.error(error)
				})
		},
		getSourceHubAllList() {
			this.listSourceHubAllData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = {}
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubAllData = result.data.ResponseData;
					for (i = 0; i < listSourceHubAllData.length; i++) {
						this.listSourceHubAllData.push({
							value: listSourceHubAllData[i].HubID,
							text: listSourceHubAllData[i].HubName + ' (' + listSourceHubAllData[i].HubID + ')',
							text1: listSourceHubAllData[i].HubName
						})
					}
				}, error => {
					console.error(error)
				})
		},
		getSourceHubNameListFlt(hubZoneId) {
			this.listSourceHubNameDataFlt = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: hubZoneId
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var listSourceHubNameDataFlt = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameDataFlt.length; i++) {
						this.listSourceHubNameDataFlt.push({
							value: listSourceHubNameDataFlt[i].HubID,
							text: listSourceHubNameDataFlt[i].HubName + ' (' + listSourceHubNameDataFlt[i].HubID + ')',
							text1: listSourceHubNameDataFlt[i].HubName
						})
					}
				}, error => {
					console.error(error)
				})
		},
		saveComboHubConfiguration() {
			var self = this
			// this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			console.log(this.listSourceHubNameDataObj.value);
			console.log(this.DesHubID);

			if (this.listSourceHubNameDataObj.value === this.DesHubID) {
				return this.$alertify.error('First Hub And Second Hub Not Same')
			}

			this.input = ({
				ComboSecondHubId: this.DesHubID,
				ComboSecondHub: this.HubName,
				HubZoneId: this.hubzoneid,
				//connectionid: this.ConnectionID,
				//connectionname: this.ConnectionName,
				CreatedBy: this.useremail,
				ComboFirstHubId: this.listSourceHubNameDataObj.value,
				ComboFirstHub: this.listSourceHubNameDataObj.text
			})
			console.log(JSON.stringify(this.input));
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'saveComboHubConfiguration',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						if (self.HubID == self.searchHubId && self.ConnectionID == self.searchConnectionID) {
							self.getconnectionDetails()
						}
						self.resetForm()
						// this.showResulstHubSection = true;
					} else {
						// this.showResulstHubSection = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					self.isLoading = false;
					this.$alertify.error('Save API Error')
					console.error(error)
				})
		},
		getAllComboHubConfigurations() {
			this.pageNo = 0
			var isErr = 0;
			if (!this.hubzoneidflt) {
				this.isSearchHubZoneErr = '1',
					this.SearchHubZoneErr = 'The HubZone field is required.'
				isErr = 1;
			} else {
				this.isSearchHubZoneErr = '',
					this.SearchHubZoneErr = ''
			}
			if (isErr == 1) {
				return false;
			} else {
				this.getAllComboHubConfigurationsDetails();
			}
		},
		getAllComboHubConfigurationsDetails() {
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getAllComboHubConfigurations?HubZoneId=' + this.hubzoneidflt,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.listComboHubDetails = result.data.ResponseData;
					} else if (result.data.ResultCode == 101) {
						console.log(result.data.ReturnMessage);
						this.$alertify.error(result.data.ReturnMessage)
						this.listComboHubDetails = '';
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},


		resetFlt() {
			this.listComboHubDetails = []
			this.isLoadingSearch = false
			this.listHubZoneObjDataFlt = {
				value: "",
				text: ""
			}
			this.hubzoneidflt = ''
			this.isSearchHubZoneErr = 0
			this.SearchHubZoneErr = ''
			this.routetypeitemList = {
				value: "",
				text: ""
			}
			this.routetypename = ''
			this.isSearchRouteTypeErr = 0
			this.SearchRouteTypeErr = ''
			this.listSourceHubNameDataObj3 = {
				value: "",
				text: ""
			}
			this.searchHubId = ''
			this.isSearchHubErr = 0
			this.SearchHubErr = ''
			this.listConnectionNameDataObj2 = {
				value: "",
				text: "",
				routeMode: ""
			}
			this.searchConnectionID = ''
			this.isSearchConnectionErr = 0
			this.SearchConnectionErr = ''
			this.IsActive = false
			this.actualRouteList = ''
		},
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						console.log('errors exist', this.errors);
						return false;
					} else {
						this.saveComboHubConfiguration();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		resetForm() {
			this.listSourceHubNameDataObj = {
				value: '',
				text: '',
				hubcode: ''
			};
			this.listHubZoneObjData = {
				value: '',
				text: ''
			};
			this.listConnectionNameDataObj = {
				value: '',
				text: ''
			};
			// this.listConnectionNameDataObj2 = {
			//   value: '',
			//   text: ''
			// };
			this.listResultHubobjData = {
				value: '',
				text: ''
			};
			this.listSourceHubNameDataObj2 = {
				value: '',
				text: ''
			}
			this.routetypeitem = {
					id: '',
					text: ''
				},
				// this.showResulstHubSection = false;
				this.hubzoneid = '';
			this.HubID = '';
			//this.listconeectionDetails = '';
			this.routetype = '';
			this.connectiontype = '';
			this.connectionname = '';
			this.resultHubID = '';
			this.ConnectionID = '';
			this.DesHubID = ''
			this.$validator.reset();

		},
		closeStatusModal() {
			this.addmodalShow = false
		},
		takeAction() {
			this[this.fncAction]()
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/combohubconfiguration/combohubconfiguration_component.js